import { render, staticRenderFns } from "./GraduationProjectRegisterRound.vue?vue&type=template&id=065b4d48&"
import script from "./GraduationProjectRegisterRound.vue?vue&type=script&lang=js&"
export * from "./GraduationProjectRegisterRound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports